import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0AvatarPerson, F0AvatarTeam, F0Icon } from '@factorialco/f0-react'
import { CardPin } from '@factorialco/f0-react/icons/app'
import type { PurchaseRequestFragment } from 'generated/resources/graphql'

import buildUrl from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'

interface Props {
  purchaseRequest: PurchaseRequestFragment
}

const PurchaseRequestSummarySidebar = ({ purchaseRequest }: Props) => {
  const requester = purchaseRequest.requesterEmployee
  const defaultLocation = requester?.locations?.find((l) => l.isDefault)
  const teamName = requester?.memberships?.[0]?.team?.name
  const manager = requester?.manager

  return (
    <Box gap="s24" paddingLeft="s16">
      <Text weight="semibold" size="200" color="grey700" caps>
        {i18n.t('procurement.purchase_requests.detail.info.requester_details')}
      </Text>

      {requester && (
        <Box gap="s16">
          <Box gap="s2">
            <Text weight="normal" size="200" color="grey700">
              {i18n.t('procurement.purchase_requests.detail.info.employee')}
            </Text>
            <Box flexDirection="row" alignItems="center" gap="s8">
              <F0AvatarPerson
                firstName={requester.fullName?.split(' ')[0] ?? ''}
                lastName={requester.fullName?.split(' ').slice(1).join(' ') ?? ''}
                src={buildUrl(requester.avatar?.url)}
                size="xs"
              />
              <Text weight="medium" size="200" color="grey1000">
                {requester.fullName || ''}
              </Text>
            </Box>
          </Box>

          {teamName && (
            <Box gap="s2">
              <Text weight="normal" size="200" color="grey700">
                {i18n.t('procurement.purchase_requests.detail.info.department')}
              </Text>
              <Box flexDirection="row" alignItems="center" gap="s8">
                <F0AvatarTeam name={teamName} size="xs" />
                <Text weight="medium" size="200" color="grey1000">
                  {teamName}
                </Text>
              </Box>
            </Box>
          )}

          {requester.email && (
            <Box gap="s2">
              <Text weight="normal" size="200" color="grey700">
                {i18n.t('procurement.purchase_requests.detail.info.email')}
              </Text>
              <Text weight="normal" size="200" color="grey1000">
                {requester.email}
              </Text>
            </Box>
          )}

          {defaultLocation?.location && (
            <Box gap="s2">
              <Text weight="normal" size="200" color="grey700">
                {i18n.t('procurement.purchase_requests.detail.info.office')}
              </Text>
              <Box flexDirection="row" alignItems="center" gap="s8">
                <F0Icon icon={CardPin} size="sm" />
                <Text weight="medium" size="200" color="grey1000">
                  {defaultLocation.location.name}
                </Text>
              </Box>
            </Box>
          )}

          {manager && (
            <Box gap="s2">
              <Text weight="normal" size="200" color="grey700">
                {i18n.t('procurement.purchase_requests.detail.info.manager')}
              </Text>
              <Box flexDirection="row" alignItems="center" gap="s8">
                <F0AvatarPerson
                  firstName={manager.fullName?.split(' ')[0] ?? ''}
                  lastName={manager.fullName?.split(' ').slice(1).join(' ') ?? ''}
                  src={buildUrl(manager.avatar?.url)}
                  size="xs"
                />
                <Text weight="medium" size="200" color="grey1000">
                  {manager.fullName || ''}
                </Text>
              </Box>
            </Box>
          )}
        </Box>
      )}
    </Box>
  )
}

export default PurchaseRequestSummarySidebar
